import Loading from './loading'

let plugin = {};

let removeDom = event => {
  event.target.parentNode.removeChild(event.target);
};
plugin.install = function(Vue){
  const LoadingConstructor = Vue.extend(Loading);

  LoadingConstructor.prototype.close = function () {
    this.visible = false;
    this.$el.addEventListener('transitionend', removeDom);
  };
  let instance;
  Vue.prototype.openLoading = (option = {}) => {
    instance = new LoadingConstructor().$mount(document.createElement('div'));
    instance.text = option.text || instance.text || option;
    instance.loadingType = option.loadingType || instance.loadingType;
    document.body.appendChild(instance.$el);
  };
  Vue.prototype.closeLoad = () => {
    instance.close();
  }
};
export default  plugin



// WEBPACK FOOTER //
// ./src/components/loadingjs.js